module.exports = __webpack_public_path__ + "img/fuelpump-icon.1c322633.png";